import React from 'react';
import PropTypes from 'prop-types';
import { MIN_CHARACTERS } from 'utils/search';
import css from '../home/ServiceCatalogContainer.scss';
import ServicesResults from './ServicesResults';
import PeopleResults from './PeopleResults';
import NoResults from './NoResults';
import ResultsPlaceholder from './ResultsPlaceholder';

export default class SearchView extends React.Component {

  hasNoResults() {
    return this.props.services.length === 0 && this.props.connections.length === 0;
  }

  get results() {
    if ( this.props.isLoading ) return <ResultsPlaceholder />;
    return this.hasNoResults() && this.props.query.length >= MIN_CHARACTERS
      ? <NoResults />
      : [
        <ServicesResults key="services" services={this.props.services} isStudent={this.props.isStudent} isServiceMember={this.props.isServiceMember} />,
        <PeopleResults key="people" connections={this.props.connections} />
      ];
  }

  render() {
    return (
      <div className={css['container']}>
        {this.results}
      </div>
    );
  }
}

SearchView.propTypes = {
  services: PropTypes.array.isRequired,
  connections: PropTypes.array.isRequired,
  query: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isServiceMember: PropTypes.bool.isRequired,
  isStudent: PropTypes.bool.isRequired
};
